











import { Component, Vue } from 'vue-property-decorator';
import SideBar from '@/components/SideBar.vue';
import NavBar from '@/components/NavBar.vue';
import FooterBar from '@/components/FooterBar.vue';
import { State, Mutation, Getter } from 'vuex-class';

@Component({
  components: {
    SideBar,
    NavBar,
    FooterBar,
  },
})
export default class ConnectedLayout extends Vue {
  @State('menuVisible') private menuVisible: boolean;
  @Mutation('closeMenu') private closeMenu: () => void;
}
